// Testimonial-Slider
// Bootstrap carousel handles auto-play via data-bs-ride="carousel"
// Uniform height: lock .carousel-inner to the tallest slide so the height
// never changes between slides and the page can't shift during transitions.
document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.testimonial-slider .carousel').forEach((carousel) => {
		const inner = carousel.querySelector('.carousel-inner');
		const items = Array.from(carousel.querySelectorAll('.carousel-item'));

		if (!inner || !items.length) {
			return;
		}

		// Vertical padding on .carousel-inner must be added to the item height,
		// otherwise the locked height comes up short and content clips.
		const verticalPadding = () => {
			const style = getComputedStyle(inner);
			return parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
		};

		// Measure every slide and lock the inner to the tallest. Re-run on font
		// load and resize so it always reflects real content. Hidden slides are
		// briefly shown (invisible) to read their true height.
		const lockToTallest = () => {
			// Clear first so a previously-set height doesn't constrain measurement
			inner.style.height = '';

			let tallest = 0;

			items.forEach((item) => {
				const hidden = !item.classList.contains('active');

				if (hidden) {
					item.style.visibility = 'hidden';
					item.style.display = 'block';
				}

				tallest = Math.max(tallest, item.offsetHeight);

				if (hidden) {
					item.style.display = '';
					item.style.visibility = '';
				}
			});

			if (tallest) {
				inner.style.height = (tallest + verticalPadding()) + 'px';
			}
		};

		lockToTallest();

		// Web fonts change text height; re-measure once they're ready and after
		// full page load so the locked height isn't based on fallback fonts.
		if (document.fonts && document.fonts.ready) {
			document.fonts.ready.then(lockToTallest);
		}
		window.addEventListener('load', lockToTallest);

		let resizeTimer;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(lockToTallest, 150);
		});
	});
});
